export const v3dynamicSubNav = {
  _type: 'v3dynamicSubNav',
  module: 'v3dynamicSubNav',
};
